import Stats from "stats.js";

export default class StatsExperience {
  stats: Stats | undefined;
  active: boolean;

  constructor() {
    this.active = window.location.hash === "#stats";
    if (this.active) {
      this.stats = new Stats();
      this.stats.showPanel(2);
      const statsContainer = document.body.appendChild(this.stats.dom);
      statsContainer.classList.add("stats");
      statsContainer.style.top = "unset";
      statsContainer.style.bottom = "0";
    }
  }

  begin() {
    if (this.active) {
      this.stats?.begin();
    }
  }

  end() {
    if (this.active) {
      this.stats?.end();
    }
  }
}
